import { EMAIL_SLIDE, PAUSE_SLIDE, PLAN_GRAPH_SLIDE, PLAN_LOADER_SLIDE, PRODUCT_SLIDE, QUESTION_ANSWER_SLIDE_COMPONENT, RESULT_SLIDE, REVIEW_SLIDE, START_SLIDE } from '../quiz-component-types';
import photosQuestionTabletSrc from '../../assets/images/slide/photos-question-tablet.png';

const QUIZ_SLIDES_V31 = [
    {
        id: 900,
        component: START_SLIDE,
        isNotIndexing: true
    },
    {
        id: 9000,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v5'
        }
    },
    {
        id: 902,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Why do you want to write this down?',
            answers: [
                {
                    text: 'I want my family to know my story',
                    id: 1
                },
                {
                    text: 'I want to understand my life better',
                    id: 2
                },
                {
                    text: 'I\'m ready to finally record my memories',
                    id: 3
                },
                {
                    text: 'It\'s a gift for someone',
                    id: 4
                },
                {
                    text: 'I want to leave something meaningful behind',
                    id: 5
                },
                {
                    text: 'I\'m simply curious',
                    id: 6
                }
            ]
        }
    },
    {
        id: 9021,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v6'
        }
    },
    {
        id: 912,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Which decade were you born in?',
            description: 'This helps Boundly ask questions that fit the world you grew up in.',
            answers: [
                {
                    text: '1930s',
                    id: 1
                },
                {
                    text: '1940s',
                    id: 2
                },
                {
                    text: '1950s',
                    id: 3
                },
                {
                    text: '1960s',
                    id: 4
                },
                {
                    text: '1970s',
                    id: 5
                },
                {
                    text: '1980s',
                    id: 6
                },
                {
                    text: '1990s',
                    id: 7
                },
                {
                    text: 'I\'d rather not say',
                    id: 8
                }
            ]
        }
    },
    {
        id: 9122,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v7'
        }
    },
    {
        id: 913,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Have you ever tried writing any of this down?',
            answers: [
                {
                    text: 'Yes quite a lot',
                    id: 1
                },
                {
                    text: 'A few notes or voice memos',
                    id: 2
                },
                {
                    text: 'I started once and stopped',
                    id: 3
                },
                {
                    text: 'Never',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9132,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v8'
        }
    },
    {
        id: 914,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'How would you rather do this?',
            answers: [
                {
                    text: 'By speaking naturally',
                    id: 1
                },
                {
                    text: 'By typing my thoughts',
                    id: 2
                },
                {
                    text: 'A mix of both',
                    id: 3
                },
                {
                    text: 'Not sure yet',
                    id: 4
                }
            ]
        }
    },
    {
        id: 915,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'How confident are you about writing and grammar?',
            answers: [
                {
                    text: 'I\'m not confident and will need help',
                    id: 1
                },
                {
                    text: 'I\'m fairly confident but open to edits',
                    id: 2
                },
                {
                    text: 'I\'m confident in both',
                    id: 3
                }
            ]
        }
    },
    {
        id: 9152,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v9'
        }
    },
    {
        id: 908,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Which story should we begin with?',
            description: 'You can change this any time',
            answers: [
                {
                    text: 'The home I grew up in',
                    id: 1
                },
                {
                    text: 'My first job',
                    id: 2
                },
                {
                    text: 'A hard year I got through',
                    id: 3
                },
                {
                    text: 'The people who raised me',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9161,
        component: RESULT_SLIDE,
        theme: 'dark',
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            title: 'The Quiet Chronicler',
            emoji: 'diamond',
            description: 'You notice things other people walk straight past. You\'ve probably replayed the same conversation in your head for years. That isn\'t overthinking. It\'s the raw material.',
            questions: [
                'Which teacher had a habit you can still imitate?',
                'Whose laugh could you pick out in a crowded room?',
                'What did your first workplace smell like?'
            ],
            answerSourceId: 902,
            propsByAnswerId: {
                1: {
                    title: 'The Keeper',
                    emoji: 'key',
                    description: 'You\'re not really doing this for yourself. There\'s a specific person behind it — someone who\'d want to know all this and isn\'t asking yet. That makes the job clearer than most people have it: not everything, just the parts they\'d never find out any other way.',
                    questions: [
                        'What did your grandmother always keep in her handbag?',
                        'What was the family car, and what was wrong with it?',
                        'What did you do after school before anyone got home?'
                    ]
                },
                2: { title: 'The Quiet Chronicler' },
                3: {
                    title: 'The Returner',
                    emoji: 'cyclone',
                    description: 'You\'ve been meaning to do this for a while. Maybe a notebook somewhere, maybe just the intention. Nothing was ever wrong with it. You only had to hold the whole thing in your head at once to begin. This time you answer one question.',
                    questions: [
                        'What was on your bedroom wall?',
                        'Which song takes you straight back?',
                        'What was the first job you were paid for?'
                    ]
                },
                4: {
                    title: 'The Sender',
                    emoji: 'love-letter',
                    description: 'You\'ve given this person a lot of things over the years. Most of them were fine. This is the one that won\'t end up in a drawer, because nobody else could have made it — and because it\'s the only gift that gets better the longer they keep it.',
                    questions: [
                        'What were you like at the age they are now?',
                        'What\'s the story about them you always end up telling?',
                        'What did the two of you do that nobody else was there for?'
                    ]
                },
                5: {
                    title: 'The Keeper',
                    emoji: 'key',
                    description: 'You\'re not really doing this for yourself. There\'s a specific person behind it — someone who\'d want to know all this and isn\'t asking yet. That makes the job clearer than most people have it: not everything, just the parts they\'d never find out any other way.',
                    questions: [
                        'What did your grandmother always keep in her handbag?',
                        'What was the family car, and what was wrong with it?',
                        'What did you do after school before anyone got home?'
                    ]
                },
                6: {
                    title: 'The Curious One',
                    emoji: 'crystal-ball',
                    description: 'You picked "curious", which usually means you\'re not convinced there\'s much here to tell. That is the single most common thing people are wrong about. Answer three questions and see what comes back.',
                    questions: [
                        'What was your nickname, and who gave it to you?',
                        'What did you spend your first paycheque on?',
                        'What\'s the most trouble you got into before you were sixteen?'
                    ]
                }
            }
        }
    },
    {
        id: 9162,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            question: 'Do you want to include photos in your digital memoir?',
            image: photosQuestionTabletSrc,
            answers: [
                {
                    text: 'Yes, definitely',
                    id: 1
                },
                {
                    text: 'Not sure yet',
                    id: 2
                }
            ]
        }
    },
    {
        id: 9164,
        component: PLAN_LOADER_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true
    },
    {
        id: 945,
        component: EMAIL_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true
    },
    {
        id: 9163,
        component: PRODUCT_SLIDE,
        theme: 'dark',
        isNotIndexing: true,
        hasProgressBar: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v3'
        }
    },
    {
        id: 9092,
        component: PLAN_GRAPH_SLIDE,
        theme: 'dark',
        isNotIndexing: true,
        hasProgressBar: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 9093,
        component: PRODUCT_SLIDE,
        theme: 'dark',
        isNotIndexing: true,
        hasProgressBar: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v4'
        }
    },
    {
        id: 9094,
        component: REVIEW_SLIDE,
        theme: 'dark',
        isNotIndexing: true,
        hasProgressBar: true,
        continueButton: {
            isVisible: true
        }
    }
];

export {
    QUIZ_SLIDES_V31
};
